enum AuthType {
  Basic = 'Basic',
  ApiKey = 'App',
  IBSSO = 'IBSSO',
  OAuth = 'Bearer',
}

export { AuthType };
